// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-hamburger-menu-layout {
  display: flex;
  flex-direction: column;
  height:100%;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.hamburger-menu-setting-back-header-container {
  display: flex;
  flex-direction: row;
  text-align: left;
  margin: 5px;
  /* background-color: rgba(0, 0, 0, 0.329); */
}

.hamburger-menu-back-button {
  background-color: rgba(235, 247, 217, 0.205);
  margin-left: 3px;
  margin-right: 3px;
  font-weight: 900;
}

.setting-menu-items-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/HamburgerMenu/pages/Settings/Settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAO;EACP,SAAS;AACX","sourcesContent":[".settings-hamburger-menu-layout {\n  display: flex;\n  flex-direction: column;\n  height:100%;\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n}\n\n.hamburger-menu-setting-back-header-container {\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n  margin: 5px;\n  /* background-color: rgba(0, 0, 0, 0.329); */\n}\n\n.hamburger-menu-back-button {\n  background-color: rgba(235, 247, 217, 0.205);\n  margin-left: 3px;\n  margin-right: 3px;\n  font-weight: 900;\n}\n\n.setting-menu-items-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
